import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { DividerModule } from 'primeng/divider';
import { ImageModule } from 'primeng/image';
import { SelectModule } from 'primeng/select';
import { SegmentedSelectComponent } from '@/shared/segmented-select/segmented-select.component';

@Component({
    selector: 'app-indagine-coppie',
    templateUrl: './indagine-coppie.component.html',
    imports: [DividerModule, DatePickerModule, CommonModule, SelectModule, ImageModule, ReactiveFormsModule, SegmentedSelectComponent],
    standalone: true
})
export class IndagineCoppieComponent {
    @Input() form!: FormGroup;
    @Input() tipoScambio!: 'SS' | 'SD' | 'SI';
    @Input() opzioniCoppie: any[] = [];
}
